module.exports = __webpack_public_path__ + "img/add-action.4d1b9bd8.svg";